import { FlexBox } from '@Backlot-Cars/archie';
import styled from 'styled-components';

const getListStyleType = ({ $ordered, $listStyleType }) => {
	return $listStyleType || ($ordered ? 'decimal' : 'disc');
};

export const ListContainer = styled(FlexBox).attrs(({ $ordered }) => ({
	as: $ordered ? 'ol' : 'ul',
	flexDirection: 'column',
}))`
	& > li {
		list-style-type: ${({ $ordered, $listStyleType }) => getListStyleType({ $ordered, $listStyleType })};
	}
`;
